export function Footer() {
  return (
    <footer className="foot">
      <div className="container foot-row">
        <div className="foot-left">
          <div className="brand">
<img className="brand-logo" src="logo.png" alt="NgineRoom" width="145" height="38" />
          </div>
          <span className="foot-tag">In stealth · 2026</span>
        </div>
        <div className="foot-links">
          <a href="#problem">The problem</a>
          <a href="#what">What we do</a>
          <a href="#how">How it works</a>
          <a href="#vision">Our view</a>
          <a href="#verticals">Who it's for</a>
        </div>
        <div className="foot-copy">© 2026 Engine Room Data &amp; AI Corp</div>
      </div>
    </footer>
  );
}
